import { Controller } from "@hotwired/stimulus"

// Skeleton + fade-in pra <img> de Active Storage.
// Resolve UX no 3G onde JPEG/PNG progressivos pintam scanlines de cima pra
// baixo conforme bytes chegam — visualmente ruim. Aqui escondemos o <img>
// (opacity 0) e mostramos um skeleton shimmering ate o load event disparar,
// dai swap com fade.
//
// Markup:
//   <div class="image-loader" data-controller="image-loader">
//     <div class="image-loader__skeleton" data-image-loader-target="skeleton"></div>
//     <img data-image-loader-target="image" ... />
//   </div>
//
// Edge cases:
//   - Imagem ja em cache do browser: img.complete=true on connect, swap imediato.
//   - load fired antes do JS connect: idem (complete check).
//   - error: marca container como erro (CSS pode mostrar broken icon).
//   - lazy loading nativo: load so dispara quando img de fato baixa.

export default class extends Controller {
  static targets = ["image", "skeleton"]

  connect() {
    if (!this.hasImageTarget) return
    const img = this.imageTarget

    if (img.complete && img.naturalWidth > 0) {
      this._reveal()
      return
    }

    this._onLoad = () => this._reveal()
    this._onError = () => this._error()
    img.addEventListener("load", this._onLoad, { once: true })
    img.addEventListener("error", this._onError, { once: true })
  }

  disconnect() {
    if (this.hasImageTarget) {
      this.imageTarget.removeEventListener("load", this._onLoad)
      this.imageTarget.removeEventListener("error", this._onError)
    }
  }

  _reveal() {
    this.element.classList.add("image-loader--loaded")
  }

  _error() {
    this.element.classList.add("image-loader--error")
  }
}
